import {AnalysisListQueryKey} from '@domain/rcfa'
import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'

export type ResponseType = {
  data: boolean
}

export const useDeleteAnalysis = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (analysisId: number) => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}`
      return (await ApiClient.axiosInstance.delete(path, {})).data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: [AnalysisListQueryKey]})
      queryClient.removeQueries({queryKey: ['stoppages']})
      return {data: true}
    }
  })
}
